export default __webpack_public_path__ + "static/media/gpac-art.6e766f62.png";